import { IconProps } from 'types/icon.type'

export const ArrowLeftIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Arrow left icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9423 3.72468C11.1863 3.96876 11.1863 4.36449 10.9423 4.60857L6.17588 9.37496H16.3337C16.6788 9.37496 16.9587 9.65478 16.9587 9.99996C16.9587 10.3451 16.6788 10.625 16.3337 10.625H6.17588L10.9423 15.3914C11.1863 15.6354 11.1863 16.0312 10.9423 16.2752C10.6982 16.5193 10.3025 16.5193 10.0584 16.2752L4.22505 10.4419C3.98097 10.1978 3.98097 9.8021 4.22505 9.55802L10.0584 3.72468C10.3025 3.48061 10.6982 3.48061 10.9423 3.72468Z"
        fill="currentColor"
      />
    </svg>
  )
}
